module.exports = __webpack_public_path__ + "assets/img/home.a3c066b6.png";